import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { motion } from 'framer-motion';
import { IoIosConstruct } from 'react-icons/io';
import { BsHouseCheck, BsShieldCheck } from 'react-icons/bs';
import { AiOutlineArrowRight } from 'react-icons/ai';

import welcome01 from '../../assets/images/welcome-01.jpg';
import welcome02 from '../../assets/images/welcome-02.jpg';
import './Welcome.css';

const Welcome = () => {
  return (
    <section className="welcome" id="AboutShort">
      <div className="container">
        <div className="welcome__inner">
          
          {/* Images Section */}
          <motion.div 
            className="welcome__images"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <img src={welcome01} alt="Roofing installation work" className="welcome__img-main" />
            <img src={welcome02} alt="Finished roofing project" className="welcome__img-secondary" />
            
            <div className="welcome__badge">
              <div className="welcome__badge-icon">
                <IoIosConstruct />
              </div>
              <div className="welcome__badge-content">
                <h3>Certified Service</h3>
                <p>Approved Roof Repairing</p>
              </div>
            </div>
          </motion.div>

          {/* Content Section */}
          <motion.div 
            className="welcome__content"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="section-label">Welcome To Our Service</div>
            <h2 className="welcome__title">Committed to Quality Roofing Solutions</h2>
            
            <h3 className="welcome__subtitle">
              Serving Commercial & Residential Clients across the nation with fast, 
              reliable, and durable roofing services.
            </h3>
            
            <p className="welcome__text">
              We leverage agile frameworks to provide a robust synopsis for high-level overviews. 
              Our iterative approaches to corporate strategy foster collaborative thinking to further 
              the overall value proposition. We organically grow the holistic worldview of disruptive 
              innovation through supreme quality products.
            </p>

            <div className="welcome__features">
              <div className="welcome__feature">
                <div className="welcome__feature-icon">
                  <BsHouseCheck />
                </div>
                <div className="welcome__feature-text">
                  <h4>Residential Solutions</h4>
                  <p>Expert installations & repairs.</p>
                </div>
              </div>
              <div className="welcome__feature">
                <div className="welcome__feature-icon">
                  <BsShieldCheck />
                </div>
                <div className="welcome__feature-text">
                  <h4>Commercial Roofing</h4>
                  <p>Durable long-lasting protection.</p>
                </div>
              </div>
            </div>

            <button className="button">
              <AnchorLink href="#Contact">Contact Us Today</AnchorLink>
              <AiOutlineArrowRight />
            </button>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Welcome;